module.exports = __webpack_public_path__ + "promotion_category.png?0c63a371ab8607eadea700f9e0fc8a10";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion_category.png
// module id = 994
// module chunks = 2